// extracted by mini-css-extract-plugin
var _1 = "RequestBoardCardMeta-moduleRequestBoardCardMeta__guKEz";
var _2 = "RequestBoardCardMeta-moduledeadline__KcVGM";
export { _1 as "RequestBoardCardMeta", _2 as "deadline" }
